class FlatMap {
    public flatMap(array, fn) {
      var value = [];
      for (var i = 0; i < array.length; i++) {
        var mapping = fn(array[i]);
        value = [...value, ...mapping];
      }
      return value;
    }
}


export default new FlatMap();